import { isEmpty } from '@/utils/utils.js'
import { IMPORT_CONTACTS_STEPS } from '../constants'

export default {
  organizationId: (state) => state.audienceSummary.data.organizationId,
  audienceSummary: (state) => (isEmpty(state.audienceSummary) == true ? {} : state.audienceSummary.data.items),
  selectTypes: (state) => {
    const optionsCurrentSelected = state.audienceSummary.data.items.filter((item) => item.type !== null).map((element) => element.type.value) || []
    const options = [...state.selectTypes]
    options.forEach((item) => {
      item.types.forEach((element) => {
        if (optionsCurrentSelected.includes(element.value)) {
          element.$isDisabled = true
          return
        }
        element.$isDisabled = false
      })
    })
    return options
  },

  optionMainColumn: (state) =>
    state.audienceSummary.data.items
      .filter((item) => item.type !== null && item.state.value !== 'IGNORED')
      .map((element) => {
        return {
          fileColumnPosition: element.fileColumnPosition,
          key: element.type.value,
          value: element.type.value,
        }
      }),

  optionMainColumSelected: (state) => {
    if (state.audienceSummary.data.audienceKeys != null) {
      return state.audienceSummary.data.audienceKeys.map((element) => {
        return {
          key: element.fieldName,
          value: element.value.toUpperCase(),
        }
      })
    }

    return state.audienceSummary.data.items
      .filter((item) => item.isKey == true)
      .map((element) => {
        return {
          fileColumnPosition: element.fileColumnPosition,
          key: element.type.value,
          value: element.type.value.toUpperCase(),
        }
      })
  },

  processAudience: (state) => state.statusAudience,
  namesColumns: (state) => state.audienceSummary.data.items.map((element) => element.fileColumnName),
  recipiend: (state) => state.recipient,
  contactInfoRecepient:
    (state) =>
    (key = true) => {
      let items = []
      state.schemaAudience.values.filter((item) => {
        if (item.isKey == key) {
          items.push({
            ...item,
            fieldValue: state.recipient[item.fieldName == null ? '' : item.fieldName],
          })
        }
      })
      return items || []
    },

  // New Audience
  isStepValid: (state) => (step) => {
    if (step === IMPORT_CONTACTS_STEPS.CREATE_AUDIENCE) return true /* Step CREATE_AUDIENCE sempre válido */

    return state.importContacts.validSteps.find((validStep) => validStep === step)
  },

  isStepCompleted: (state) => (step) => {
    return state.importContacts.completedSteps.find((completedStep) => completedStep === step)
  },

  hasAnyAudienceKeyOnImport: (state) => {
    return state.importContacts.importedData?.audienceKeys?.length > 0
  },

  hasAnyAudienceKeyOnItem: (state) => {
    return state.importContacts.importedData?.items?.some((item) => item.isKey)
  },
}
